module.exports = __webpack_public_path__ + "img/mongolfiera.eeda20f3.png";